module.exports = __webpack_public_path__ + "static/media/signage-industrial-img35.51d3c12f.jpg";